export const FEATURE = {
  LISTING_NEW_CAR: 'LISTING_NEW_CAR',
  BRANCH_LISTING_PAGE: 'BRANCH_LISTING_PAGE',
  BRANCH_DETAIL_PAGE: 'BRANCH_DETAIL_PAGE',
  SALES_LISTING_PAGE: 'SALES_LISTING_PAGE',
  SALES_DETAIL_PAGE: 'SALES_DETAIL_PAGE',
  SUKU_CADANG: 'SUKU_CADANG',
  LISTING_PROMO: 'LISTING_PROMO',
  TEST_DRIVE: 'test drive',
  TEST_DRIVE_LISTING_PAGE: 'TEST_DRIVE_LISTING_PAGE',
};
